import {fnPic, fnRouter} from "@/fn";
import {downStat} from "@/api/material";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {getStadiumDownStar} from "@/api/act/rabbit";

let TupianDownloadMixin = {

  components: {},

  methods: {
    downloadFree(tupianItem, channel, from = 'venue', downloadPicType = 'pic') {

      let {uniq_id} = tupianItem;
      let topicDetail = this.detail
      // let tempChannel = 2
      fnPic.downloadTopicPic(topicDetail, channel, uniq_id, from).then(res => {
        let {status, time, layer, url, msg, d_type} = res.data.data;
        if (status === 1) {
          /* 下载 1图片 2图片包 */
          downStat({uniq_id, module: downloadPicType})

          /* 如果下载是免费下载次数，弹出非盈利弹框 */
          if (parseInt(d_type) === 1) {
            setTimeout(() => {
              if (this.downloadCount.free_remain == 0) {
                // this.$refs.GuideDownloadCount.init();
                this.$store.commit('home/SET_IS_SHOW_GUIDE_DOWNLOAD_COUNT', true)
              } else {
                // this.$refs.ProfitModal.isShowFreeDownload = true
                this.$store.commit('pic/SET_FREE_DOWN_DIALOG', {isShow: true})

              }
            }, 600)
          }

        } else if (status == 0 || status == 2 || status == 3) {
          if (layer == 2) {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
          } else if (layer == 3) {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
          } else if (layer == 4) {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.COMPANY);
          } else {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
          }
        } else if (status === -200) {
          this.$store.commit('tupian/SET_DOWN_INTERCEPT_DIALOG', {isShow: true, clippingTime: time})

        }
      })
    },
    download(tupianItem, channel) {
      this.downloadFree(tupianItem, channel)
    },
    downloadSourceFiles(tupianItem, channel, from = 'venue', downloadPicType = 'pic') {
      // this.downloadFree(tupianItem, channel)
      let {uniq_id} = tupianItem;
      let topicDetail = this.detail
      fnPic.downloadTopicPic(topicDetail, channel, uniq_id, from).then(res => {
        let {status, time, layer, url, msg, d_type} = res.data.data;
        if (status === 1) {
          /* 下载 1图片 2图片包 */
          downStat({uniq_id, module: downloadPicType})
          setTimeout(() => {
            if (this.downloadCount.free_remain == 0) {
              this.$store.commit('home/SET_IS_SHOW_GUIDE_DOWNLOAD_COUNT', true)
            } else {
              this.$store.commit('pic/SET_FREE_DOWN_DIALOG', {isShow: true})
            }
          }, 600)

        } else if (status == 0 || status == 2 || status == 3) {
          if (layer == 2) {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
          } else if (layer == 3) {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
          } else if (layer == 4) {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.COMPANY);
          } else {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
          }
        } else if (status === -200) {
          this.$store.commit('tupian/SET_DOWN_INTERCEPT_DIALOG', {isShow: true, clippingTime: time})
        }
      })
    },
    buyBusinessVip() {
      let path = fnRouter.getRouterLink(PAGE_PATH.PAYMENT.BUSINESS)
      fnRouter.navigationTo(path)
    },
    buyTupianPackage(tupianItem) {
      this.$store.commit('tupianPackage/SET_TUPIAN_PACKAGE_PAY_DIALOG', {isShow: true, tupianItem})
    },
    downloadTupianPackage(tupianItem, channel) {
      let {uniq_id} = tupianItem;

      fnPic.downloadPicPackage(channel, uniq_id).then(res => {
        let {status, time, layer, url, msg, d_type} = res.data.data;
        if (status === 1) {

        } else if (status === 0 || status === 2 || status === 3) {

        } else if (status === -200) {
          this.$store.commit('tupian/SET_DOWN_INTERCEPT_DIALOG', {isShow: true, clippingTime: time})
        }
      })
    },
    downloadTupianPackageSourceFiles(tupianItem, channel) {
      this.downloadTupianPackage(tupianItem, channel);
    },
  }
}

export default TupianDownloadMixin;
